<template>
  <el-dialog 
    :visible.sync="modalVisible" 
    :title="isOther ? 'Others' : 'Delivery Order In Charge'"
    width="90%"
    append-to-body
  >
    <tw-process-group-list-edit-delivery-table
      v-if="visible"
      :is-edit-mode="false"
      :is-other="isOther"
      :is-modal="true"
    />
  </el-dialog>
</template>

<script>
import TwProcessGroupListEditDeliveryTable from '@/components/molecules/TwProcessGroupListEditDeliveryTable';

export default {
  name: 'TwProcessGroupListEditDeliveryTableModal',
  components: {
    TwProcessGroupListEditDeliveryTable
  },
  props: {
    visible: Boolean,
    deliveryOrderList: Array,
    isOther: Boolean
  },
  computed: {
    modalVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    }
  }
};
</script>
